import * as tslib_1 from "tslib";
import React from 'react';
import SwitchBase from '../SwitchBase';
import RadioButtonCheckedIcon from '../internal/svg-icons/RadioButtonChecked';
import RadioButtonUncheckedIcon from '../internal/svg-icons/RadioButtonUnchecked';
/**
 * 单选框组件（只有图标）。推荐使用`Radio`组件。
 */
function RadioButton(props) {
    return (React.createElement(SwitchBase, tslib_1.__assign({ inputType: "radio", icon: React.createElement(RadioButtonUncheckedIcon, null), checkedIcon: React.createElement(RadioButtonCheckedIcon, null) }, props)));
}
export default RadioButton;
//# sourceMappingURL=RadioButton.js.map